import React from "react";

function StatusChip({ value = "pending", onClickHandler = () => {} }) {
  const backGroundColor = {
    cancelled: "#FEF2F2",
    done: "#ECFCCB",
    expired: "#F1F5F9",
    pending: "#FEF9C3",
  };
  const color = {
    cancelled: "#EF4444",
    done: "#65A30D",
    expired: "#94A3B8",
    pending: "#CA8A04",
  };
  return (
    <div
      style={{
        borderRadius: "32px",
        padding: "10px 12px",
        backgroundColor: backGroundColor[value.toLowerCase()] ?? "#fff",
        fontSize: "12px",
        fontWeight: 510,
        textTransform: "uppercase",
        textAlign: "center",
        color: color[value.toLowerCase()] ?? "#020617",
      }}
      onClick={onClickHandler}
    >
      {value}
    </div>
  );
}

export default StatusChip;
